import {
  CreditosOrganizacion,
  CreditosSuborganizacion,
  CreditosUsario,
  CreditosSuscripcion,
} from "./iDataCreditos";

export enum DashboardType {
  ALL_ORGS = "ALL_ORGS",
  SINGLE_ORG = "SINGLE_ORG",
  SUSCRS = "SUSCRS",
  SUBORGS = "SUBORGS",
  USERS = "USERS",
}

export type DashboardDataMap = {
  [DashboardType.ALL_ORGS]: CreditosOrganizacion[];
  [DashboardType.SINGLE_ORG]: CreditosOrganizacion[];
  [DashboardType.SUBORGS]: CreditosSuborganizacion[];
  [DashboardType.USERS]: CreditosUsario[];
  [DashboardType.SUSCRS]: CreditosSuscripcion[];
};

export const endpointMap: Record<DashboardType, string> = {
  [DashboardType.ALL_ORGS]: "creditos-organizacion",
  [DashboardType.SINGLE_ORG]: "creditos-organizacion",
  [DashboardType.SUBORGS]: "creditos-suborgs",
  [DashboardType.USERS]: "creditos-usuario",
  [DashboardType.SUSCRS]: "creditos-suscripcion",
};

export type CreditosRequestParams =
  | { id_organizacion: string }
  | { id_usuario: string }
  | { id_suborganizacion: string }
  | { id_suscripcion: string }
  | {};

export interface PageInfo {
  dashboardType: DashboardType;
  filter: CreditosRequestParams;
  title: string | null;
  label: string | null;
}

